import React from 'react'
import styles from './head.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const Head = ({ classes, children, className, style }) => (
  <div style={style} className={classNames(classes.container, className)}>
    {children}
  </div>
)

export default injectSheet(styles)(Head)
